
/**
 * 课程选择
 */

 export const CourseSelectList=[
    {
        prop:"name",
        label:"试卷名称",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"cate",
        label:"试卷分类",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"status",
        label:"状态",
        width:"150",
        format: "status",
        order: false,
        isShow:true
    },
    {
        prop:"creatorName",
        label:"创建人",
        width:"150",
        format: "creatorName",
        order: false,
        isShow:true
    },
    {
        prop:"creationTime",
        label:"创建时间",
        width:"150",
        format: "date",
        order: false,
        isShow:true
    },
 ]

